module.exports = __webpack_public_path__ + "media/bgmusic.a04a393a.mp3";